<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="用户昵称" label-width="80px">
        <el-input v-model="name" clearable placeholder="用户昵称"> </el-input>
      </el-form-item>
      <el-form-item label="手机号" label-width="80px">
        <el-input v-model="phone" clearable placeholder="手机号"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
        <el-button type="success" @click="getdwon()" v-if="hasAuth('sys:user:export')">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" :data="tableData" border stripe style="width: 100%;" tooltip-effect="dark"
      @selection-change="handleSelectionChange">
      <el-table-column align="center" label="用户头像" min-width="120">
        <template slot-scope="scope"><img :src="scope.row.avatarUrl" alt="" height="50px" width="50px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户昵称" min-width="120" prop="nickName"></el-table-column>
      <el-table-column align="center" label="用户手机号" min-width="120" prop="phone"></el-table-column>
      <el-table-column align="center" label="拉新并下单人数" min-width="120">
        <template slot-scope="{ row }">
          <span style="cursor: pointer; color: #42ca4d;" @click="detail(row, 1)">{{ row.numberNum || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="性别" min-width="100" prop="phone">
        <template slot-scope="{ row }">
          <span v-if="row.gender == 1">
            男
          </span>
          <span v-if="row.gender == 2">
            女
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作记录" min-width="200" prop="phone">
        <template slot-scope="{ row }">
          浏览商品数：<span style="cursor: pointer; color: red;" @click="detail(row, 2)">{{ row.browseProductsNum || 0
            }}</span><br />
          购物车商品数：<span style="cursor: pointer; color: red;" @click="detail(row, 3)">{{ row.shoppingCarNum || 0
            }}</span><br />
          未付款订单：<span style="cursor: pointer; color: red;" @click="detail(row, 4)">{{ row.noPayNum || 0 }}</span><br />
          已付款订单：<span style="cursor: pointer; color: red;" @click="detail(row, 5)">{{ row.payNum || 0 }}</span><br />
          已完成订单：<span style="cursor: pointer; color: red;" @click="detail(row, 6)">{{ row.completeNum || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="位置" min-width="200" prop="address"></el-table-column>
      <el-table-column align="center" label="账户余额" prop="money" width="200"></el-table-column>
      <el-table-column align="center" label="注册时间" min-width="160" prop="createTime"></el-table-column>
      <el-table-column align="center" label="邀请达人" min-width="140" prop="storeName"></el-table-column>
      <el-table-column align="center" fixed="right" width="200" label="操作" prop="icon">
        <template slot-scope="scope">
          <el-button plain type="success" v-if="hasAuth('sys:user:add')"
            @click="UpdateConfigTypeButton(scope.row)">充值</el-button>
          <el-button plain type="warning" @click="RecordsButton(scope.row)"
            v-if="hasAuth('sys:user:jilu')">充值记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="current" :page-size="size" :page-sizes="[10, 20, 50, 100]" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <detail ref="visible" />
    <chongzhi ref="czvisible" @shuaxin="getStoreGoods" />
    <records ref="recvisible" />
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";
import detail from "./detail.vue";
import chongzhi from "./chongzhi.vue";
import ExportJsonExcel from "js-export-excel";
import records from "./records.vue";
import ty from "../../utils/ty";
import axios from "axios";
export default {
  name: "ConfigType",
  components: {
    VploadImg,
    detail,
    chongzhi,
    records,
  },
  data() {
    return {
      searchForm: {},
      shopForm: {},
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      filesd: [],
      editForm: {},
      total: 0,
      size: 10,
      current: 1,
      name: "",
      phone: "",
    };
  },
  created() {
    this.getConfigType();
  },
  methods: {
    getdwon() {
      var that = this;
      var obj = {
        name: that.name,
        phone: that.phone
      }
         var token = sessionStorage.getItem("token");
      if (token) {
        var items = [
          { pos: token.length - 1, str: "AGhdGAUE6Y" },
          { pos: 38, str: "V22" },
          { pos: 26, str: "Sy" },
          { pos: 18, str: "Hi" },
          { pos: 10, str: "Ti" },
          { pos: 1, str: "Ai" },
        ];

        for (let item of items) {
          if (
            token.substring(item.pos, item.pos + item.str.length) === item.str
          ) {
            token =
              token.substring(0, item.pos) +
              token.substring(item.pos + item.str.length);
          } else {
            const idx = token.indexOf(item.str);
            if (idx !== -1)
              token =
                token.substring(0, idx) +
                token.substring(idx + item.str.length);
          }
        }
      }
      axios({
        method: "post",
        url: ty.apiurl + "/admin/userBase/exportUserList",
        data: obj,
        headers: {
          Authorization: token,
        },
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "用户列表.xlsx");
          link.click();
          link = null;
        })
        .catch((error) => {
        });
    },
    getStoreGoods(e) {
      this.current = 1;
      this.getConfigType();
    },
    detail(i, o) {
      this.$refs.visible.init({ userId: i.userId, type: o });
    },
    RecordsButton(i) {
      this.$refs.recvisible.init(i.userId);
    },
    delHandle(id) {
      this.$axios
        .post("/admin/brand/delete", {
          id: id,
        })
        .then((res) => {
          this.getConfigType();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => { },
          });
        });
    },

    handleClose() {
      this.dialogVisible = false;
    },

    submitForm() {
      if (this.id) {
        this.$axios
          .post("/admin/homeCarouse/updateHomeCarouse", {
            id: this.id,
            imgUrl: this.imgUrl,
            name: this.name,
            sort: this.sort,
            state: 1,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => { },
            });
          });
      } else {
        this.$axios
          .post("/admin/brand/add", {
            cover: this.imgUrl,
            name: this.name,
            sort: this.sort,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => { },
            });
          });
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getConfigType();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getConfigType();
    },

    //获取常量数据配置列表
    getConfigType() {
      this.$axios
        .post("/admin/userBase/getUserList", {
          pageNo: this.current,
          pageSize: this.size,
          phone: this.phone,
          name: this.name,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
        });
    },
    UpdateConfigTypeButton(i) {
      this.$refs.czvisible.init(i.userId);
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
